import { render, staticRenderFns } from "./SxCompanyMachineView.vue?vue&type=template&id=0348a7e8&scoped=true&"
import script from "./SxCompanyMachineView.vue?vue&type=script&lang=js&"
export * from "./SxCompanyMachineView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0348a7e8",
  null
  
)

export default component.exports